import {getAppSessionCookieHeader, handleSessionId} from "../appCookie";
import api from "../../Api";

export const createProfile = async (customer) => {
  const resp = await api.post('profile/save' + getAppSessionCookieHeader(), customer).then((response) => {
    return response.data;
  }).catch(function (error) {
    return handleError(error);
  });

  return resp;
}

export const saveCustomerFamily = async (customer) => {
  const resp = await api.post('profile/family/save' + getAppSessionCookieHeader(), customer).then((response) => {
    return response.data;
  }).catch(function (error) {
    return handleError(error);
  });

  return resp;
}

export const redeemGiftCard = async (client, req) => {
  const resp = await api.post('client/gift/card/redeem/' + client.guid + getAppSessionCookieHeader(), req).then((response) => {
    handleSessionId(response);
    return response.data;
  }).catch(function (error) {
    return handleError(error);
  });

  return resp;
}

export const transferCustomerGiftCard = async (client, giftCard) => {
  return await api.post('client/giftCard/transfer/' + client.guid + getAppSessionCookieHeader(), giftCard).then((response) => {
    return response.data;
  });
}

export const changeCustomerLocation = async (locationId, client) => {
  return await api.post('client/location/assign/' + locationId + getAppSessionCookieHeader(), client).then((response) => {
    return response.data;
  });
}

export const printOrder = async (extOrderId) => {
  const resp = await api.get('cart/terminal/print/' + extOrderId + getAppSessionCookieHeader()).then((response) => {
    return response.data;
  }).catch(function (error) {
    return handleError(error);
  });

  return resp;
}

export const getCustomerSales = async (guid, viewAll) => {
  let _req = viewAll ? '' : '?limit=25';
  const resp = await api.get('client/sales/' + guid + _req + getAppSessionCookieHeader()).then((response) => {
    return response.data;
  }).catch(function (error) {
    return handleError(error);
  });

  return resp;
}

export const addToFavorites = async (guid, request) => {
  const resp = await api.post('client/favorites/' + guid + getAppSessionCookieHeader(), request).then((response) => {
    return response.data;
  }).catch(function (error) {
    return handleError(error);
  });

  return resp;
}

export const removeFromFavorites = async (guid, request) => {
  const resp = await api.post('client/favorites/remove/' + guid + getAppSessionCookieHeader(), request).then((response) => {
    return response.data;
  }).catch(function (error) {
    return handleError(error);
  });

  return resp;
}

export const customerBatchImport = async (request) => {
  const resp = await api.post('client/batch/import' + getAppSessionCookieHeader(), request).then((response) => {
    return response.data;
  }).catch(function (error) {
    return handleError(error);
  });

  return resp;
}

export const customerConvertData = async (request, importType) => {
  const resp = await api.post('admin/data/conversion/' + importType + '/preview' + getAppSessionCookieHeader(), request).then((response) => {
    return response.data;
  }).catch(function (error) {
    return handleError(error);
  });

  return resp;
}

export const bulkImportMemberships = async (request, importType) => {
  const resp = await api.post('admin/company/memberships/csv' + getAppSessionCookieHeader(), request).then((response) => {
    return response.data;
  }).catch(function (error) {
    return handleError(error);
  });

  return resp;
}


function handleError(error) {
  let err = {
    error: true,
    message: error.response.data.message
  }
  return err;
}
